import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        width: 20,
        height: 20,
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    line: {
        position: 'absolute',
        width: 16,
        height: 2,
        borderRadius: 2,
        backgroundColor: 'currentColor',
        transition: 'transform 220ms ease, opacity 220ms ease',
        transformOrigin: 'center',
    },
    topClosed: {
        transform: 'translateY(-4px) rotate(0deg)',
    },
    bottomClosed: {
        transform: 'translateY(4px) rotate(0deg)',
    },
    topOpen: {
        transform: 'translateY(0) rotate(45deg)',
    },
    bottomOpen: {
        transform: 'translateY(0) rotate(-45deg)',
    },
}));

const MenuToggleIcon = ({ isOpen, className }) => {
    const classes = useStyles();

    return (
        <Box className={`${classes.root}${className ? ` ${className}` : ''}`}>
            <Box className={`${classes.line} ${isOpen ? classes.topOpen : classes.topClosed}`} />
            <Box className={`${classes.line} ${isOpen ? classes.bottomOpen : classes.bottomClosed}`} />
        </Box>
    );
};

MenuToggleIcon.propTypes = {
    isOpen: PropTypes.bool,
    className: PropTypes.string,
};

export default MenuToggleIcon;
